import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'deNLize',
})
export class deNLizePipe implements PipeTransform {
	transform(value: string): string {
		let replacedText = value.replaceAll(String.raw`\n`, '\n');
		replacedText = replacedText.replaceAll('\n', '\n');
		// replacedText = replacedText.replace(/<br>/g, '');
		return replacedText;
		// .replace( /(<([^>]+)>)/ig, '');
	}
}
